import React, { useState } from "react";

/**
 * Fallback renderer for unknown block types.
 * Displays the payload as a collapsible JSON tree with a "Convert to..." hint.
 */
export default function GenericBlockViewer({
  type,
  payload,
}: {
  type: string;
  payload: Record<string, unknown>;
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      style={{
        border: "1px dashed var(--c-border)",
        borderRadius: 8,
        padding: 12,
        backgroundColor: "var(--c-surface-2)",
      }}
    >
      <div className="flex items-center justify-between">
        <span
          className="text-xs font-semibold uppercase tracking-wide"
          style={{ color: "var(--c-warning)" }}
        >
          Unknown block type: {type}
        </span>
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-xs px-2 py-0.5 rounded"
          style={{
            color: "var(--c-text-secondary)",
            backgroundColor: "var(--c-surface-3)",
            border: "1px solid var(--c-border)",
          }}
        >
          {expanded ? "Collapse" : "Expand JSON"}
        </button>
      </div>
      {expanded && (
        <pre
          className="mt-2 text-xs overflow-auto"
          style={{
            color: "var(--c-text-secondary)",
            maxHeight: 400,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {JSON.stringify(payload, null, 2)}
        </pre>
      )}
      {!expanded && (
        <p className="mt-1 text-xs" style={{ color: "var(--c-text-faint)" }}>
          {Object.keys(payload).length} keys in payload
        </p>
      )}
    </div>
  );
}
